

<template>
  <div class="globalheader">
    <div class="mainContainer disFlex between">
      <div :class="activeFlag==0?activeClass:nameClass" @click="changeFlag(0,'/Home')"><span>首页</span></div>
      <div :class="activeFlag==1?activeClass:nameClass" @click="changeFlag(1,'/Product')"><span>宣教中心</span></div>
      <div :class="activeFlag==2?activeClass:nameClass" @click="changeFlag(2,'/Forensics')"><span>取证查询</span></div>
      <div :class="activeFlag==3?activeClass:nameClass" @click="changeFlag(3,'/Notice')"><span>通知公告</span></div>
      <!-- 企业管理员 -->
      <div v-if="isDenglu&&(currentUser.roleCodes.indexOf('COM_ADMIN_AQKT')>=0||currentUser.roleCodes.indexOf('COM_ADMIN')>=0)"
        :class="activeFlag==4?activeClass:nameClass" @click="changeFlag(4,'/Company')"><span
          v-if="currentUser">管理中心</span></div>
      <!-- 企业用户 -->
      <div v-if="isDenglu"
        :class="activeFlag==5?activeClass:nameClass" @click="changeFlag(5,'/Learning')"><span
          v-if="currentUser">个人中心</span></div>

      <!-- 未登录  占位置 -->
      <div :class="nameClass" v-if="!isDenglu"></div>
      <div :class="nameClass" style="text-align: right;">
        <div v-if="!isDenglu">
          <span>
            <span @click="toLogin()">登录</span>
            <span style="padding: 0 3px;">/</span>
            <span @click="toRegist()">注册</span>
          </span>
        </div>
        <span v-if="isDenglu" style="font-size: 14px;display: flex;align-items: center;justify-content:flex-end;">

          <el-avatar size="medium" :src="currentUser.avatarurl?wjSrc+currentUser.avatarurl:txsrc"
            style="margin: 0 5px;"></el-avatar>

          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="color: #fff;">
              {{currentUser.realName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
                <el-dropdown-item>螺蛳粉</el-dropdown-item> -->
              <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>


        </span>
      </div>
    </div>
  </div>
</template>
<!-- COM_ADMIN_AQKT -->
<script>
  export default {
    name: 'GlobalHeader',
    props: ['currentUser', 'isDenglu', 'activeFlag', 'isGg','wjSrc'],
    data() {
      return {
        nameClass: 'flex1',
        activeClass: 'flex1 active',
        txsrc:require('../assets/images/notxsex.png')
      }
    },
    methods: {
      changeFlag: function(flag, path) {
        this.$router.push(path);
        this.$emit('changerouter', flag)
      },
      // 跳转注册页面
      toRegist: function() {
        this.$router.push('/Register');
      },
      // 跳转登录页面
      toLogin: function() {
        this.$router.push('/Login');
      },
      handleCommand(command) {
        if (command == 'loginOut') {
          this.$confirm('您确定要退出登录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.get('/j_spring_security_logout?sys=hse&token='+this.currentUser.tokenpc, {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              }
            }).then(res => {
              var data = res.data;
              if (data.stat == '1') {
                // this.$emit('getUserInfo', '');
                localStorage.clear('currentUser');
                this.$router.push('/Login');
              } else {}
            })
          }).catch(() => {

          });
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .globalheader {
    background-color: #0071BA;
    height: 57px;
    width: 100%;
  }

  .flex1 {
    line-height: 57px;
    text-align: center;
  }

  .flex1 {
    height: 57px;
    cursor: pointer;
    transition: all 0.3s left;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .flex1.active {
    background-color: #025A93;
  }
</style>



// WEBPACK FOOTER //
// src/components/GlobalHeader.vue